import React from 'react';
import { CheckCircle2, Download, Plus, RefreshCw } from 'lucide-react';

export default function ReelReady({ project, onAnother, onChange }) {
  const videoUrl = project.finishedVideoUrl || '/demo-reel.mp4';
  return (
    <div className="mx-auto max-w-xl text-center">
      <CheckCircle2 className="mx-auto text-green-400" size={58} />
      <h2 className="mt-4 text-3xl font-bold">Your Reel Is Ready</h2>
      <div className="mt-6 overflow-hidden rounded-2xl border border-gray-800 bg-black">
        <video className="aspect-[9/16] max-h-[65vh] w-full bg-black object-contain" controls playsInline preload="metadata"><source src={videoUrl} type="video/mp4" />Your browser cannot preview this video.</video>
      </div>
      <a href={videoUrl} download={`${project.title || 'vasia-reel'}.mp4`} className="mt-6 inline-flex min-h-14 w-full items-center justify-center gap-2 rounded-xl bg-purple-600 px-5 py-3 font-bold hover:bg-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-300"><Download size={20} /> DOWNLOAD REEL</a>
      <button onClick={onAnother} className="mt-3 inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-xl border border-gray-700 px-5 py-3 font-semibold hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-purple-300"><Plus size={18} /> CREATE ANOTHER REEL</button>
      <button onClick={onChange} className="mt-2 inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-xl text-sm text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-purple-300"><RefreshCw size={17} /> REQUEST A CHANGE</button>
    </div>
  );
}

